import React from 'react'
import { useIntl } from 'react-intl'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import { Toggle } from '../../legacy-design-system/toggle'
import { CsWarningIcon } from '../../legacy-design-system/icons'

interface ToggleSettingsItemProps {
  readonly title: string
  readonly description: string
  readonly descriptionLink?: string
  readonly info?: string
  readonly onToggle: (enabled: boolean) => void
  readonly enabled: boolean
  readonly show?: boolean
  e2eId?: string
  linkUrlId?: string
}

export const toggleSettingsItemTestId = 'toggle-settings-item'

export function ToggleSettingsItem({
  title,
  description,
  descriptionLink,
  info,
  onToggle,
  enabled,
  show = true,
  e2eId,
  linkUrlId
}: ToggleSettingsItemProps) {
  const intl = useIntl()

  return !show ? (
    <span></span>
  ) : (
    <span>
      <div
        className={css`
          margin-top: 6px;
          margin-right: 8px;
          width: 100%;
          display: flex;
        `}
      >
        <div
          className={css`
            font-size: 17px;
            font-weight: ${deprecatedTheme.fontWeights.secondary.bold};
            color: ${theme.color.neutral100};
            padding-right: 20px;
          `}
        >
          {title}
        </div>

        <Toggle
          onChange={() => {
            onToggle(!enabled)
          }}
          checked={enabled}
          e2eId={e2eId}
        />
        {info && (
          <div
            className={css`
              padding-left: 20px;
              padding-right: 5px;
            `}
          >
            <CsWarningIcon color={theme.color.neutral100} size={18} />
          </div>
        )}
        {info}
      </div>

      <div
        className={css`
          font-size: 14px;
          color: ${theme.color.neutral50};
        `}
      >
        {description}
        {descriptionLink && linkUrlId && (
          <a href={intl.formatMessage({ id: linkUrlId })} target="_blank">
            {' '}
            {descriptionLink}
          </a>
        )}
      </div>
    </span>
  )
}
